import { render, staticRenderFns } from "./PanelVentas.vue?vue&type=template&id=e1516ff2&"
import script from "./PanelVentas.vue?vue&type=script&lang=js&"
export * from "./PanelVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports